<div class="row">
  <div class="col">
    <div class="card shadow-sm my-2">
      <ng-content></ng-content>
    </div>
  </div>
</div>
